import axiosClient from './axiosClient';

export const saveInquiry = (inquiry) => {
	return axiosClient.post("/inquiries", inquiry);
}

export const getStoreInquiryTypes = (storeId) => {
	return axiosClient.get(`/inquiries/stores/${storeId}/inquiry-types`);
}
